import { render, staticRenderFns } from "./EcTabs.vue?vue&type=template&id=41d4db0e"
import script from "./EcTabs.vue?vue&type=script&lang=js"
export * from "./EcTabs.vue?vue&type=script&lang=js"
import style0 from "./EcTabs.vue?vue&type=style&index=0&id=41d4db0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports